define.alias("shared/components/shared/mobile/drawer/carousel-card", "preview-grid/components/shared/mobile/drawer/carousel-card");